export interface Action {
  type: string;
  state: any;
}
export const SET_IS_NAV_FROM_MENU = "SET_IS_NAV_FROM_MENU";

export const setEmployeeDetails = (data: boolean): Action => ({
  type: SET_IS_NAV_FROM_MENU,
  state: data,
});